import { axios } from "@/services/axios";
import { merge,has,extend,} from "lodash";
import { currentUser } from "@/services/auth";


const transformResponse = data =>
  merge({}, data, {
    query: data.query || {},
    alert: data.alert || {},
    destinations: data.destinations || [],
    tags: data.tags || [],
    user: data.user || currentUser,

  });

  const transformRequest = data => {
    const newData = Object.assign({}, data);
    if (newData.query_id === undefined) {
      newData.query_id = newData.query.id;
      newData.alert_id = newData.alert;
      delete newData.query;
      delete newData.alert;
      delete newData.is_favorite;
    }
    
    return newData;
  };

export class AlertEvent {
  constructor(alert) {
    extend(this, alert);

    if (!has(this, "alert")) {
      this.options = {};
    }
    if (!has(this, "query")) {
      this.query = {};
    }
    if (!has(this, "tags")) {
      this.tags = [];
    }
    if (!has(this, "user")) {
      this.user = currentUser;
    }
    if (!has(this, "destination")) {
      this.destinations = [];
    }

  }

  isNew() {
    return this.id === undefined;
  }

  getUrl() {
    return `alerts/${this.id}`;
  }

  favorite() {
    return AlertEvent.favorite(this.id);
  }

  unfavorite() {
    return AlertEvent.unfavorite(this.id);
  }

}
const saveOrCreateUrl = data => (data.id ? `api/alert_events/${data.id}` : "api/alert_events");


const AlertEventService = {
  query: params => axios.get("api/alert_events", { params }),
  get: ({ id }) => axios.get(`api/alert_events/${id}`).then(transformResponse),
  delete: id => axios.delete(`api/alert_events/${id}`),
  recent: params => axios.get("api/alert_events/recent", { params }),
  archive: params => axios.get("api/alert_events/archive", { params }),
  myAlertEvents: params => axios.get("api/alert_events/my", { params }),
  favorites: params => axios.get("api/alert_events/favorites", { params }),
  favorite:  id => axios.post(`api/alert_events/${id}/favorite`),
  unfavorite: id => axios.delete(`api/alert_events/${id}/favorite`),
  mute: data => axios.post(`api/alert_events/${data.id}/mute`),
  unmute: data => axios.delete(`api/alert_events/${data.id}/mute`),
  get_from_alert_id: ({ id }) => axios.get(`api/alerts/${id}/fevents`),
};

AlertEventService.save = data => axios.post(saveOrCreateUrl(data), transformRequest(data)).then(transformResponse);

extend(AlertEvent, AlertEventService);

export default AlertEvent;